import cookies from 'cookies-js';

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if(data && data.errors)
        return Promise.reject(data.errors);
     
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    if(data && data.errors)
        return Promise.reject(data.errors);

    return data;
  });
}

const handle = (promise) => promise
  .then(data => ([data, undefined]))
  .catch(error => Promise.resolve([undefined, error]));

function get(url, options = {}) {
  let requestOptions = {
    method: 'GET',
    ...options,
  };

  if(cookies.get('spoofedUser')){
    requestOptions.headers = new Headers({
      'X-Switch-User': cookies.get('spoofedUser')
    })
  }
  
  return handle(fetch(url, requestOptions).then(handleResponse));
}

function getDocument(url, options = {}) {
  let requestOptions = {
    method: 'GET',
    ...options,
  };

  if(cookies.get('spoofedUser')){
    requestOptions.headers = new Headers({
      'X-Switch-User': cookies.get('spoofedUser')
    })
  }

  return handle(fetch(url, requestOptions).then(response => response));
}

function post(url, body, options = {}) {
  let headers = new Headers({
    'Content-Type': 'application/json'
  })
  
  if(cookies.get('spoofedUser')){
    headers.append('X-Switch-User', cookies.get('spoofedUser'))
  }

  const requestOptions = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body),
    ...options,
  };
  
  return handle(fetch(url, requestOptions).then(handleResponse));
}

function postFormData(url, formData, options = {}) { 
  let headers = new Headers({})
  if(cookies.get('spoofedUser')){
    headers.append('X-Switch-User', cookies.get('spoofedUser'))
  }

  const requestOptions = {
    method: "POST",
    headers: headers,
    body: formData,
    ...options,
  };
  
  return handle(fetch(url, requestOptions).then(handleResponse));
}

function put(url, body, options = {}) {
  let headers = new Headers({
    'Content-Type': 'application/json'
  })
  if(cookies.get('spoofedUser')){
    headers.append('X-Switch-User', cookies.get('spoofedUser'))
  }

  let requestOptions = {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(body),
    ...options,
  };
  return handle(fetch(url, requestOptions).then(handleResponse));
}

function patch(url, body, options = {}) {
  let headers = new Headers({
    'Content-Type': 'application/json'
  })

  if(cookies.get('spoofedUser')){
    headers.append('X-Switch-User', cookies.get('spoofedUser'))
  }

  let requestOptions = {
    method: 'PATCH',
    headers: headers,
    body: JSON.stringify(body),
    ...options,
  };
  return handle(fetch(url, requestOptions).then(handleResponse));
}

function del(url, options = {}) {
  let headers = new Headers({
    'Content-Type': 'application/json'
  })
  
  if(cookies.get('spoofedUser')){
    headers.append('X-Switch-User', cookies.get('spoofedUser'))
  }
  let requestOptions = {
    method: 'DELETE',
    headers: headers,
    ...options,
  };
  return handle(fetch(url, requestOptions).then(handleResponse));
}

const API = {
  get,
  patch,
  post,
  postFormData,
  put,
  delete: del,
  getDocument,
};

export default API;
